import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Patient, PatientAdapter } from './patient.model';
import { Practitioner, PractitionerAdapter } from './practitioner.model';

export type Person = Patient | Practitioner;

@Injectable({ providedIn: 'root' })
export class PersonAdapter {
  constructor(
    private patientAdapter: PatientAdapter,
    private practitionerAdapter: PractitionerAdapter,
  ) {}

  fromResource$(
    fhirPerson: fhir4.Patient | fhir4.Practitioner | fhir4.Person,
  ): Observable<Person> {
    if (fhirPerson.resourceType === 'Patient') {
      return this.patientAdapter.fromResource$(fhirPerson as fhir4.Patient);
    } else if (fhirPerson.resourceType === 'Practitioner') {
      return this.practitionerAdapter.fromResource$(
        fhirPerson as fhir4.Practitioner,
      );
    }

    return of();
  }
}
